<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header
            v-model="alert.show"
            @hidden="closeModal()"
        >
            <card shadow type="secondary" class="m--4">
                <span class="close cursor-pointer" @click="alert.show = false">&times;</span>
                <div class="row text-center">
                    <div class="col-lg-12 py-4">
                        <div v-html="alert.icon"></div>
                    </div>
                    <div class="col-lg-12">
                        <h2 v-html="alert.emphasize"></h2>
                        <h4 v-html="alert.text"></h4>
                    </div>
                    <div class="col-lg-12 py-4">
                        <b-button variant="primary" class="px-5" @click="closeModal()">
                            {{ (alert.btnCloseText) ? alert.btnCloseText: 'ตกลง' }}
                        </b-button>
                    </div>
                </div>
            </card>
            
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ModalAlert" ,
    props: {
        alert: Object,
    },
    methods: {
        closeModal(){
            this.alert.show = false
            this.alert.icon = ""
            this.alert.emphasize = ""
            this.alert.text = ""
            this.alert.btnCloseText = ""
        },
    }
}
</script>
